import PinchosLogo from '../../public/assets/images/pinchos-circle-logo.png';
import Image from 'next/image';
import isMobile from '../../lib/utils/isMobile';
import { useRouter } from 'next/router';
import useBookingParams from '../../hooks/useBookingParams';
import Link from 'next/link';
import { useContext, useEffect, useRef, useState } from 'react';
import { StringsContext } from '../../lib/StringsContext';
import { getString } from '../string';

interface Props {
  title: JSX.Element;
  subtitle?: string | JSX.Element;
  hideLogo?: boolean;
  backButton?: boolean;
}

export default function Hero({ title, subtitle, hideLogo, backButton }: Props) {
  const { params } = useBookingParams();
  const router = useRouter();
  const strings = useContext(StringsContext);
  const [navbarTitle, setNavbarTitle] = useState('');

  const isAppVersionPresentAndString =
    typeof params.appVersion === 'string' && params.appVersion.length > 0;

  useEffect(() => {
    if (params.isApp) {
      if (title && title.props) {
        const result = getString(title.props.id, strings);
        if (result && result.value) {
          setNavbarTitle(result.value);
        }
      }
    }
  }, [title, strings, params.isApp]);

  useEffect(() => {
    if (params.isApp && isAppVersionPresentAndString) {
      let androidSuccess = false;
      try {
        //@ts-ignore
        Android.setNavbarTitle(navbarTitle);
        androidSuccess = true;
      } catch (error) {
        console.error('Error setting navbar title on Android:', error);
      }

      if (!androidSuccess) {
        try {
          //@ts-ignore
          window.webkit.messageHandlers.navbar.postMessage(navbarTitle);
        } catch (error) {
          console.error('Error setting navbar title on iOS:', error);
        }
      }
    }
  }, [navbarTitle, params.isApp, isAppVersionPresentAndString]);

  const showTitle = !params.isApp || (params.isApp && !isAppVersionPresentAndString);
  const showSubtitle = !params.isApp || (params.isApp && isAppVersionPresentAndString);

  return (
    <div className="short:hidden">
      {params.isApp || !isMobile() || hideLogo ? null : (
        <Link
          href={`${window?.location?.origin.replace('reservation.', '')}/restaurant/${
            router.query.venueId
          }`}
          className="absolute left-5 top-6"
        >
          <Image src={PinchosLogo} alt="Pinchos logo" height="32" width="32" />
        </Link>
      )}
      {/* {backButton ? (
        <button
          type="button"
          onClick={navigateBack}
          className="relative w-6 h-6 p-0 border-none bg-transparent"
        >
          <Icon type="arrowPrevious" className="text-darkGold" />
        </button>
      ) : null} */}
      {showTitle && title && (
        <h1 className={`pt-6 text-center uppercase tracking-[0.25em] ${isMobile() ? 'pb-1' : ''}`}>
          {title}
        </h1>
      )}
      {showSubtitle && subtitle && (
        <h2
          data-testid="venue-header"
          className={`text-center uppercase ${params.isApp ? 'pt-6 tracking-widest' : ''} ${
            isMobile() ? 'pb-1' : ''
          }`}
        >
          {subtitle}
        </h2>
      )}
    </div>
  );
}
